<!-- 特色乡村--政务服务板块 -->
<template>
    <div class="con">
        <div>
            <div class="top_title" :style="{color, borderColor: borderBottomColor }">
                <div style="display: flex;justify-content: center;align-items: center;">
                    <img style="margin-right:5px;" :src="imgSrc" alt="" srcset="">
                    <span class="test_text" >事项公开</span>
                </div>
            </div>
            <div class="tab-box" v-show="name == '县本级'">
                <el-button size="medium" :class="{ activeButton: activeName == '1' }"
                    @click="changeTab('1')">按生命周期</el-button>
                <el-button size="medium" style="width: 111.6px;" :class="{ activeButton: activeName == '2' }"
                    @click="changeTab('2')">按部门</el-button>
            </div>
            <div class="tb_box" v-show="activeName == '1'" style="padding-top:15px;">
                <div class="tb_tit" :style="{ '--color': color }">
                    <span :class="activeServiceType == '1' ? 'is_active' : 'tb_tit_item'"
                        @click="handleClick(1)">个人服务</span>
                    <span :class="activeServiceType == '2' ? 'is_active' : 'tb_tit_item'" @click="handleClick(2)">法人服务</span>
                </div>
                <div class="tb_cont">
                    <div class="list" v-show="activeServiceType == '1'">
                        <div class="list-item" v-for="(item, index) in PersonalServiceList" :key="index"
                            @click="toLifeCycle(item, '1')">
                            <!-- <img :src="setBgColor(item.name)" alt="" width="40px;" height="auto"> -->
                            <div class="svg_box">
                                <svg-icon :icon-class="setBgColor(item.name)" :bgcolor="color"></svg-icon>
                            </div>                            
                            <span style="color:#000;width:50%;display: inline-block;">{{ item.name }}</span>
                        </div>
                    </div>
                    <div class="list" v-show="activeServiceType == '2'">
                        <div class="list-item" v-for="(item, index) in CorporateServicesList"
                            @click="toLifeCycle(item, '2')" :key="index">
                            <!-- <img :src="setBgColor(item.name)" alt="" width="40px;" height="auto"> -->
                            <div class="svg_box">
                                <svg-icon :icon-class="setBgColor(item.name)" :bgcolor="color"></svg-icon>
                            </div>                            
                            <span style="color:#000;width:50%;display: inline-block;">{{ item.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dept_list" v-show="activeName == '2'">
                <div class="dept_list_item" v-for="(item, index) in deptList" :key="index" @click="toLifeCycle(item, '3')">
                    {{ item.deptName }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { lifeCycleMatter, GetdeptList, unauthorized } from "@/api/map/index";
// import svgIcon from "@/components/SvgIcon/SvgIcon";
export default {
    name: 'GovernmentServices',
    // components: {svgIcon},
    props: {
        matterList: [],  //事项列表
        mapId: [], //当前区县点位id
        name: '',  //当前区县名称
        imgSrc: '',
        color: '',
        borderBottomColor: '',
        boxBorderColor: '',  //div 边框颜色
        btnBJcolor: '',
        hoverBJcolor: ''
    },
    data() {
        return {
            topTitle: this.$route.params.topTitle,
            deptId: '',
            activeName: "1",
            activeServiceType: '1',
            PersonalServiceList: [],   //个人服务列表
            CorporateServicesList: [], //法人服务列表
            itemImg: {
                '其他':'11',
                '工作': 'P_2',
                '升学': 'P_1',
                '购房': 'P_3',
                '结婚': 'P_4',
                '生育': 'P_5',
                '失业': 'P_6',
                '创业': 'P_7',
                '迁居': 'P_8',
                '退休': 'P_9',
                '后事': 'P_10',
                '开办企业': 'L_1',
                '申请资质': 'L_2',
                '投资立项': 'L_3',
                '扩大生产': 'L_4',
                '引进人才': 'L_5',
                '办理社保': 'L_6',
                '申请专利': 'L_7',
                '缴纳税费': 'L_8',
                '申请破产': 'L_9',
                '申请贷款': 'L_10',
            },
            deptList: [],  //部门列表
            // setStyle:{
            //     '--activeColor':this.color,
            // }
        }
    },
    mounted() {
        if (sessionStorage.getItem("topTitle")) {
            this.topTitle = sessionStorage.getItem("topTitle");
        }
        // if (sessionStorage.getItem("deptObj")) {
        //     this.deptId = JSON.parse(sessionStorage.getItem("deptObj")).deptId;
        //     // this.id = JSON.parse(sessionStorage.getItem("deptObj")).id;
        // }
        this.getPersonalServices();
    },
    computed: {
        setStyle() {
            return {
                '--activeColor': this.color,
            }
        }
    },
    methods: {
        // 到事项公开
        // toDisclosure() {
        //     let concatName
        //     if (this.name == '县本级') {
        //         concatName = '汉源县政务服务中心'
        //     } else {
        //         concatName = this.name + '便民服务中心'
        //     }
        //     let mapIds = [];
        //     this.mapId.forEach(el => {
        //         mapIds.push(el.id)
        //     });
        //     let deptObj = { topTitle: concatName, deptId: '', id: mapIds };
        //     this.$router.push({
        //         name: "Disclosure",
        //         params: deptObj
        //     });
        //     sessionStorage.setItem('topTitle', concatName)
        //     sessionStorage.setItem('deptObj', JSON.stringify(deptObj));
        // },
        // 获取个人服务列表
        getPersonalServices() {
            let params = {
                serviceTypeId: '1',
                deptId: this.deptId,
            }
            let obj={method:'/zwmap/lifeCycleMatter',body:JSON.stringify(params)}
            // lifeCycleMatter(params).then((res) => {
            unauthorized(obj).then((res) => {
                if (res.data.code == 200 && res.data.data.length > 0) {
                    this.PersonalServiceList = res.data.data;
                    // 每个生命周期事项只展示4个，先删除多余事项
                    for (let index = 0; index < this.PersonalServiceList.length; index++) {
                        if (this.PersonalServiceList[index].matters && this.PersonalServiceList[index].matters.length > 0) {
                            this.PersonalServiceList[index].matters.splice(4);
                        }
                    };
                    let obj = this.PersonalServiceList[0];
                    this.PersonalServiceList.splice(0, 1);
                    this.PersonalServiceList.push(obj)
                }
            })
        },
        // 获取法人服务列表
        getCorporateservices() {
            let params = {
                serviceTypeId: '2',
                deptId: this.deptId,
            }
            let obj={method:'/zwmap/lifeCycleMatter',body:JSON.stringify(params)}
            // lifeCycleMatter(params).then((res) => {
            unauthorized(obj).then((res) => {
                if (res.data.code == 200 && res.data.data.length > 0) {
                    this.CorporateServicesList = res.data.data;
                    // 每个生命周期事项只展示4个，先删除多余事项
                    for (let index = 0; index < this.CorporateServicesList.length; index++) {
                        if (this.CorporateServicesList[index].matters && this.CorporateServicesList[index].matters.length > 0) {
                            this.CorporateServicesList[index].matters.splice(4);
                        }
                    };
                    let obj = this.CorporateServicesList[0];
                    this.CorporateServicesList.splice(0, 1);
                    this.CorporateServicesList.push(obj)
                }
            })
        },
        // 获取部门列表
        GetdeptList() {
            let obj={method:'/zwmap/deptList',body:''}
            // GetdeptList().then((res) => {
            unauthorized(obj).then((res) => {
                // console.log(res, '部门列表')
                if (res.data.data && res.data.data.length > 0) {
                    this.deptList = res.data.data;
                }
            })
        },
        // 按生命周期/部门
        changeTab(val) {
            if (val == '1') {
                this.getPersonalServices();
                this.activeName = '1';
                this.activeServiceType = '1';
            } else {  //查部门
                this.activeName = '2';
                this.GetdeptList();
            }
        },
        // 个人服务/法人服务切换
        handleClick(val) {
            if (val == '1') {
                this.getPersonalServices();
                this.activeName = '1';
                this.activeServiceType = '1';
            } else {
                this.getCorporateservices();
                this.activeName = '1';
                this.activeServiceType = '2';
            }
        },
        // 生命周期详情页
        toLifeCycle(item, type) {

            if (type == '1' || type == '2') {
                let obj = { lifeCycleId: item.lifeCycleId, name: this.name, serviceTypeId: type, deptId: this.deptId, id: this.mapId, };
                this.$router.push({
                    name: "LifeCycle",
                    params: obj
                });
                if (this.name == '县本级') {
                    obj.name = '汉源县政务服务中心'
                }
                sessionStorage.setItem('lifeCycleDetails', JSON.stringify(obj));
            } else {//根据部门查询
                let obj = { lifeCycleId: item.lifeCycleId, name: item.deptName, serviceTypeId: '', deptId: item.deptId };
                this.$router.push({
                    name: "LifeCycle",
                    params: obj
                });
                sessionStorage.setItem('lifeCycleDetails', JSON.stringify(obj));
            }
            sessionStorage.setItem('topTitle', this.name)
        },
        // 设置每项生命周期背景颜色
        setBgColor(name) {
            switch (name) {
                case '其他':
                    return this.itemImg['其他']
                    break;
                case '工作':
                    return this.itemImg['工作']
                    break;
                case '开办企业':
                    return this.itemImg['开办企业']
                    break;
                case '投资立项':
                    return this.itemImg['投资立项']
                    break;
                case '申请资质':
                    return this.itemImg['申请资质']
                    break;
                case '升学':
                    return this.itemImg['升学']
                    break;
                case '购房':
                    return this.itemImg['购房']
                    break;
                case '结婚':
                    return this.itemImg['结婚']
                    break;
                case '生育':
                    return this.itemImg['生育']
                    break;
                case '失业':
                    return this.itemImg['失业']
                    break;
                case '创业':
                    return this.itemImg['创业']
                    break;
                case '迁居':
                    return this.itemImg['迁居']
                    break;
                case '退休':
                    return this.itemImg['退休']
                    break;
                case '后事':
                    return this.itemImg['后事']
                    break;
                case '扩大生产':
                    return this.itemImg['扩大生产']
                    break;
                case '引进人才':
                    return this.itemImg['引进人才']
                    break;
                case '办理社保':
                    return this.itemImg['办理社保']
                    break;
                case '申请专利':
                    return this.itemImg['申请专利']
                    break;
                case '缴纳税费':
                    return this.itemImg['缴纳税费']
                case '申请贷款':
                    return this.itemImg['申请贷款']
                    break;
                case '申请破产':
                    return this.itemImg['申请破产']
                    break;
                default:
                    break;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.con {
    width: 1200px;
    margin: 0 auto;
    margin-top: 25px;
}

.tab-box {
    text-align: left;
    padding-top: 15px;
    // border-bottom: 1px solid #E2E2E2;
}

.top_title {
    font-size: 25px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #EBA970;
}

.btn {
    color: #3CA4EC;
    border: 1px solid #A7D4F5;
}

.text_btn {
    color: #A2A2A2;
}

.activeButton {
    background-color: #31A9FF;
    color: #fff;
}

.active_textButton {
    color: #31A9FF
}

.list {
    display: flex;
    flex-wrap: wrap;
    margin: 15px 5px;
    color: #fff;
}

.list-item {
    width: 265px;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 35px;
    box-sizing: border-box;
    color: #fff;
    margin: 0 32px 30px 0;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    cursor: pointer;
    background-color: #fff;
}

.dept_list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
}

.dept_list .dept_list_item {
    width: 220px;
    height: 50px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    text-align: center;
    margin: 0 20px 20px 0;
    line-height: 50px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding: 0 10px;
    box-sizing: border-box;
    cursor: pointer;
    background-color: #fff;
}

.list-item .list-item-title,
.list-item ul>li {
    margin: 15px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.list-item .list-item-title {
    font-size: 20px;
    color: #fff;
    cursor: pointer;
}

.li-circle {
    width: 6px;
    height: 6px;
    background-color: #fff;
    display: inline-block;
    border-radius: 50%;
    margin-right: 5px;
    margin-bottom: 3px;
}

.tb_tit {
    height: 40px;
    text-align: left;
    border-bottom: 2px solid #d3d4d7;
}

.tb_tit_item {
    display: inline-block;
    width: 85px;
    height: 40px;
    line-height: 40px;
    font-weight: 550;
    cursor: pointer;
}

.is_active {
    color: var(--color);
    border-bottom: 2px solid;
    border-color: var(--color);
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-right: 20px;
    font-weight: 550;
}
.svg_box{
    width: 50%;
    line-height: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>